// import gift from "../../assets/images/gift.svg";
import React, { Fragment } from "react";

const GiftBox = ({ t }) => {
	return (
		<Fragment>
			<div className="outer-gift-box">
				<div className="inner-gift-box">
					<div className="gift-box-columns">
						<div className="gift-box-right">
							<div className="gift-box-right-title">
								*{t("now")}, <div className="textb"> {t("caseOfRenewal")}</div>{" "}
								{t("inAMonth")} <div className="textb"> {t("gift")} 1GB </div>{" "}
								{t("tenDays")}
							</div>
							{/*<div className="gift-box-right-content">*/}
							{/*    Για να ενημερωθείς για τους Όρους ανανεώσεων κάνε κλικ <a href="#" className="textb">εδώ</a>.*/}
							{/*</div>*/}
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default GiftBox;
